import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import store from '@/store';
import CInput from '@/components/shared/CInput';
import CButton from '@/components/shared/CButton';
import { type CSelectItem, Primitive } from '@/components/shared/CSelect';
import { SPECIAL_CATEGORY_VALUES } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import { PRESET_CATEGORIES } from '@/components/DesignStudio/ImageEffectsProperties/core/presets';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderSearch',
  setup(__props) {

const searchInputRef = ref('');

const selectedCategoryValue = computed(() => store.getters['imageEffectsProperties/selectedCategoryValue']);
const hasActiveFilters = computed(() => store.getters['imageEffectsProperties/hasActiveFilters']);

const categoryOptions = computed(() => [
    { label: 'All Categories', value: SPECIAL_CATEGORY_VALUES.ALL },
    { label: 'Free', value: SPECIAL_CATEGORY_VALUES.FREE },
    ...PRESET_CATEGORIES.map((cat) => ({
        label: cat.label,
        value: cat.category
    }))
]);

const handleSearchInput = () => {
    store.dispatch('imageEffectsProperties/updateSearchQuery', searchInputRef.value);
};

const handleCategorySelectChange = (event: Event) => {
    const target = event.target as HTMLSelectElement;
    const selectedValue = target.value as CSelectItem<Primitive> | Primitive;
    store.dispatch('imageEffectsProperties/updateCategoryValue', selectedValue);
};

const handleClearFilters = () => {
    store.dispatch('imageEffectsProperties/clearFilters');
    searchInputRef.value = '';
};

return { __sfc: true,searchInputRef, selectedCategoryValue, hasActiveFilters, categoryOptions, handleSearchInput, handleCategorySelectChange, handleClearFilters, CInput, CButton }
}

})